import { useCallback, useEffect, useRef } from 'react';

interface ComponentProps {
  name: string;
  value: boolean;
  isDisabled: boolean;
  onChange: (value: boolean) => void;
}

export const Checkbox = ({
  name,
  value,
  isDisabled,
  onChange,
}: ComponentProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!inputRef?.current) return;

    if (value !== inputRef.current.checked) {
      inputRef.current.checked = value;
    }
  }, [value]);

  const onChangeHandler = useCallback(() => {
    if (!inputRef?.current) return;

    onChange(inputRef.current.checked);
  }, [onChange]);

  return (
    <input
      data-test="agree-with-terms-checkbox"
      type="checkbox"
      id={name}
      ref={inputRef}
      onChange={onChangeHandler}
      disabled={isDisabled}
    />
  );
};
